// eslint-disable-next-line no-duplicate-imports
import ThemeSwitch from './components/ThemeSwitch/ThemeSwitch';
import ThemeProviderWrapper from './providers/ThemeProvider';
import themeSlice, { selectTheme } from './store/theme/themeSlice';
import { themeNames } from './store/theme/themeSlice.contracts';

export {
  ThemeProviderWrapper,
  ThemeSwitch,
  selectTheme,
  themeNames,
  themeSlice,
};
